var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('add-service',{attrs:{"scrollY":_vm.scrollY}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }